(() => {
  if (window.mizunoniwaBlogOrderLoaded) return;
  window.mizunoniwaBlogOrderLoaded = true;

  const initialize = async (list) => {
    if (list.dataset.orderStarted) return;
    list.dataset.orderStarted = 'true';
    const originalNodes = [...list.children];
    try {
      const requestedOrder = JSON.parse(list.dataset.order);
      const page = Number(list.dataset.page);
      const pages = Number(list.dataset.pages);
      const pageSize = Number(list.dataset.pageSize);
      const total = Number(list.dataset.total);
      const selector = '[data-mn-blog-order]';
      const cardsFrom = (element) => [...element.querySelectorAll(':scope > [data-mn-article-id]')];
      const batches = new Map([[page, cardsFrom(list)]]);
      const pending = Array.from({ length: pages }, (_, i) => i + 1).filter(n => n !== page);
      list.setAttribute('aria-busy', 'true');
      const worker = async () => {
        while (pending.length) {
          const n = pending.shift();
          const url = new URL(window.location.href);
          url.hash = '';
          url.searchParams.set('page', String(n));
          url.searchParams.set('section_id', list.dataset.sectionId);
          const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
          if (!response.ok) throw new Error('Article page unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = [...document.querySelectorAll(selector)].find(el => el.dataset.sectionId === list.dataset.sectionId);
          if (!source || Number(source.dataset.total) !== total || Number(source.dataset.page) !== n) throw new Error('Article list changed');
          batches.set(n, cardsFrom(source));
        }
      };
      await Promise.all(Array.from({ length: Math.min(3, pending.length) }, worker));
      const chronological = Array.from({ length: pages }, (_, i) => batches.get(i + 1)).flat();
      const byId = new Map(chronological.map(card => [card.dataset.mnArticleId, card]));
      if (byId.size !== total || chronological.length !== total) throw new Error('Incomplete article list');
      const selected = new Set();
      const ordered = [];
      for (const id of requestedOrder) {
        if (byId.has(id) && !selected.has(id)) {
          ordered.push(byId.get(id));
          selected.add(id);
        }
      }
      for (const card of chronological) {
        if (!selected.has(card.dataset.mnArticleId)) ordered.push(card);
      }
      const visible = ordered.slice((page - 1) * pageSize, page * pageSize);
      visible.forEach((card, index) => {
        card.querySelectorAll('img').forEach(img => { img.loading = index < 3 ? 'eager' : 'lazy'; });
      });
      list.replaceChildren(...visible);
      list.dataset.orderState = 'ready';
    } catch (error) {
      list.replaceChildren(...originalNodes);
      list.dataset.orderState = 'fallback';
      console.warn('Blog order: displaying publication order.', error);
    } finally {
      list.removeAttribute('aria-busy');
    }
  };

  const scan = (root) => root.querySelectorAll('[data-mn-blog-order]').forEach(initialize);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
